import { render } from "./Quota.vue?vue&type=template&id=6dbbedef"
import script from "./Quota.vue?vue&type=script&lang=js"
export * from "./Quota.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/Quota.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6dbbedef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6dbbedef', __exports__)) {
    api.reload('6dbbedef', __exports__)
  }
  
  module.hot.accept("./Quota.vue?vue&type=template&id=6dbbedef", () => {
    api.rerender('6dbbedef', render)
  })

}


export default __exports__